// ─────────────────────────────────────────────────────────────────────────────
// UserRoleContext.jsx — Phase 2
// Provides user role and exercise context to the entire app without prop drilling.
//
// Usage in any component:
//   import { useUserRole } from '../context/UserRoleContext';
//   const { userRole, readOnly, exerciseId, userName } = useUserRole();
//
// Roles:
//   TRAINER — full access, Tab 7 trainer panel visible
//   STUDENT — Tab 7 trainer panel hidden, Tabs 1-6 read-only when in a room
//   GUEST   — same as STUDENT permissions, Tabs 1-6 always editable
// ─────────────────────────────────────────────────────────────────────────────

import { createContext, useContext } from 'react';

// Default context values (used when no Provider is found — should not happen)
const defaultContext = {
  userRole:   'GUEST',    // 'TRAINER' | 'STUDENT' | 'GUEST'
  readOnly:   false,      // true when STUDENT is inside an active exercise room
  exerciseId: null,       // uuid of the active exercise room (STUDENT only)
  studentId:  null,       // uuid of the student row in Supabase (STUDENT only)
  trainerId:  null,       // uuid from Supabase Auth (TRAINER only)
  userName:   '',         // display name
  sessionCode: null,      // exercise session code e.g. 'ROMEO-7' (STUDENT only)
  isAdmin:    false,      // true when trainer has is_admin = true in profiles table
};

export const UserRoleContext = createContext(defaultContext);

// Convenience hook — import this in components instead of useContext directly
export const useUserRole = () => useContext(UserRoleContext);
